import { Flex, Text } from '@chakra-ui/react';
import { PromoCodeRowProps } from '../types';
import formatMoney from '../../../utils/money';

/**
 * Promo code discount row component
 * Displays promo code information and discount amount
 */
const PromoCodeRow = ({ code, value }: PromoCodeRowProps): JSX.Element => (
  <Flex justify="space-between">
    <Text fontSize="sm">
      Promo Code (
      {code}
      )
    </Text>
    <Text fontSize="sm" fontWeight="medium">
      -
      {formatMoney(value)}
    </Text>
  </Flex>
);

export default PromoCodeRow;
